export enum CartProductHasVolumePriceEnum {
  Yes = 'yes',
  No = 'no'
}
